// extracted by mini-css-extract-plugin
export default {"priceList":"PriceList_priceList__bVE4y","title":"PriceList_title__iYhtM","table":"PriceList_table__LIwOY","description":"PriceList_description__502iq"};